import React from 'react'
import './banner.scss';

const Banner = () => {
  return (
    <section className='main_banner'id="home">
      <div className='custom-container'>
<img src='\assets\bannershaddow.png' className='imgbanner'/>
      <div className='inner_banner'>
        <h2>The Infrastructure Layer for <span>Scaling Web3 Projects</span> </h2>
        <p>Let your users deposit and withdraw any major token from any chain — without ever seeing a bridge, swap, or conversion screen.</p>
        <div className='buuton_banner'>
          <button>Get Started<img src='\assets\buttonn.svg'/></button>
        </div>
      </div>
      </div>

    </section>
  )
}

export default Banner
